exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/food-benefit.module/features/foodBenefitDelegations/foodBenefitDelegations.scss
// module id = 1588
// module chunks = 0